<script setup lang="ts">
import HelpeeSharingView from './helpee-sharing/HelpeeSharingView.vue';
</script>

<template>
  <HelpeeSharingView />
</template>
